//import { useCallback, useEffect, useMemo, useState } from "react";
import {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import CButton from "../../common/CButton";
import { Button, Modal } from "react-bootstrap";
import CommonDropdown from "../../common/CommonDropdown";
import { AddInquiryRemarks} from "../../services/inquiryService";
import CommonMessage from "../../common/CommonMessage";
import CPunchRes from "../../common/CPunchRes";

const Ringing = () => {
    const inquiryRef = useRef(null);
    //const [refreshKey, setRefreshKey] = useState(0);
    const [isAdmin, setIsAdmin] = useState(false);
        //const [isSales, setIsSales] = useState(false);
        const [isPunch, setIsPunch] = useState(false);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [remarksLoading, setRemarksLoading] = useState(false);
   
    const [message, setMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [errors, setErrors] = useState({});
    const [updateStatus, setUpdateStatus] = useState("");
    const [formData, setFormData] = useState({
        remarks: "",
        followUpDate: "",
        //status: "",
    });

    const [showRemarksHistory, setShowRemarksHistory] = useState(false);
const [selectedRemarks, setSelectedRemarks] = useState([]);


    const openRemarksHistory = (row) => {
    setSelectedRemarks(row.remarks || []);
    setShowRemarksHistory(true);
};

const closeRemarksHistory = () => {
    setSelectedRemarks([]);
    setShowRemarksHistory(false);
};

   useEffect(() => {
    const roleId = Number(localStorage.getItem("roleid"));
    const role = localStorage.getItem("rolename")?.toLowerCase();

    const userPermissionRoleId = Number(
        localStorage.getItem("userPermissionRoleId")
    );

    const salesPunchRoleId = Number(
        localStorage.getItem("salesPunchRoleId")
    );

    if (roleId === 1 || role === "admin") {
        setIsAdmin(true);
        setCurrentUserId(null);
    } else if (roleId === salesPunchRoleId) {
        setIsPunch(true);
        setCurrentUserId(null);
    } else if (roleId === userPermissionRoleId) {
        setCurrentUserId(Number(localStorage.getItem("userid")));
    }
}, []);


    const RemarksStatus = [
        { id: 1, name: "Interested" },
        { id: 2, name: "Not Interested" },
        { id: 4, name: "Ringing" },
        { id: 3, name: "Closed" },
    ]
    const handleChange = ({ target: { name, value } }) => {
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));

        setErrors(prev => ({
            ...prev,
            [name]: "",
        }));
    };

    

    // Open popup
    const openRemarksPopup = useCallback((rowData) => {
        setSelectedRow(rowData);
        setShowModal(true);
        setUpdateStatus("");
        setFormData({
            remarks: "",
            followUpDate: "",
        });
        setErrors({});
    }, []);

    // Close popup
    const closeRemarksPopup = useCallback(() => {
        setShowModal(false);
        setSelectedRow(null);
        setUpdateStatus("");
        setFormData({
            remarks: "",
            followUpDate: "",
        });
        setErrors({});
    }, []);
    const validate = useCallback(() => {
        const newErrors = {};

        if (!updateStatus) {
            newErrors.status = "Please select status.";
        }
        if (Number(updateStatus) === 1 && !formData.followUpDate) {
            newErrors.followUpDate = "Please select follow-up date.";
        }
        if (!formData.remarks.trim()) {
            newErrors.remarks = "Please enter remarks.";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    }, [updateStatus, formData]);


    // Confirm Cancel
    const handleRemarksOrder = useCallback(async () => {
    if (!selectedRow || !validate()) return;

    setRemarksLoading(true);

    try {
        const response = await AddInquiryRemarks({
            inquiryDataId: selectedRow.id,
            followUpStatusId: Number(updateStatus),
            followUpDate:
                Number(updateStatus) === 1
                    ? formData.followUpDate
                    : null,
            remarks: formData.remarks.trim(),
            isPunchRes:true,
        });

        if (response?.success) {
            setMessage(response.message || "Remarks added successfully.");
            inquiryRef.current?.refresh();
            closeRemarksPopup();
        } else {
            setMessage(response?.message || "Unable to save remarks.");
        }
    } catch (err) {
        setMessage(
            err?.response?.data?.message ||
            err?.message ||
            "Something went wrong."
        );
    } finally {
        setRemarksLoading(false);
    }
}, [
    selectedRow,
    updateStatus,
    formData,
    validate,
    closeRemarksPopup,
]);

    const columnDefs = useMemo(() => [
        !isAdmin && !isPunch && {
            headerName: "Remarks",
            cellRenderer: (params) => (
                <CButton
                    data={params.data}
                    onClick={openRemarksPopup}
                    buttontext="Add Remarks"
                />
            ),
        },
        {
            headerName: "Name",
            field: "name",
        },
        {
            headerName: "Mobile",
            field: "mobile",
        },
        {
            headerName: "Consultation",
            field: "consultation",
        },
        {
            headerName: "Address",
            field: "address",
        },
        {
            headerName: "PinCode",
            field: "pinCode",
        },
        {
            headerName: "City",
            field: "city",
        },
        {
            headerName: "State",
            field: "state",
        },
        // {
        //     headerName: "Follow Up Status",
        //     field: "followUpSts",
        // },
        // {
        //     headerName: "Follow Up Date",
        //     field: "followUpDate",
        // },
        {
    headerName: "Remarks",
    field: "remarks",
    width: 140,
    sortable: false,
    filter: false,
    cellRenderer: ({ data }) => {
        const count = data.remarks?.length || 0;

        return (
            <span
                style={{
                    color: "#0d6efd",
                    cursor: count > 0 ? "pointer" : "default",
                    textDecoration: count > 0 ? "underline" : "none",
                    fontWeight: 600,
                }}
                onClick={() => {
                    if (count > 0) {
                        openRemarksHistory(data);
                    }
                }}
            >
                {count} Remark{count !== 1 ? "s" : ""}
            </span>
        );
    },
},
{
  headerName: "Assign Date",
  field: "assignDate",
  valueFormatter: (params) => {
    if (!params.value) return "";

    const date = new Date(params.value);

    return date.toLocaleDateString("en-GB"); // 21/07/2026
  },
}
    ].filter(Boolean), [
        isAdmin,
    isPunch,
    openRemarksPopup,
    ]);

    return (
        <>

           <CPunchRes
    ref={inquiryRef}
    columnDefs={columnDefs}
    h4="Customer Deny"
    userId={currentUserId}
    punch={null}
    ringing={true}
    deny={null}
/>

            <Modal
                show={showModal}
                onHide={closeRemarksPopup}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Remarks</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>
                        <strong>Inquiry ID :</strong> {selectedRow?.id}
                    </p>

                    <div className="mb-3">
                        <CommonDropdown
                            label="Select Status"
                            options={RemarksStatus}
                            value={updateStatus}
                            onChange={(value) => {
                                setUpdateStatus(Number(value));
                                setErrors(prev => ({
                                    ...prev,
                                    status: "",
                                }));
                            }}
                            placeholder="Select Status"
                        />

                        {errors.status && (
                            <div className="text-danger mt-1">
                                {errors.status}
                            </div>
                        )}
                    </div>

                    {Number(updateStatus) === 1 && (
                        <div className="mb-3">
                            <label className="form-label">
                                Follow-up Date & Time
                            </label>

                            <input
                                type="datetime-local"
                                name="followUpDate"
                                className={`form-control ${errors.followUpDate ? "is-invalid" : ""
                                    }`}
                                value={formData.followUpDate}
                                onChange={handleChange}
                                min={new Date().toISOString().slice(0, 16)}
                            />

                            {errors.followUpDate && (
                                <div className="invalid-feedback">
                                    {errors.followUpDate}
                                </div>
                            )}
                        </div>
                    )}

                    <div className="mb-3">
                        <textarea
                            name="remarks"
                            rows={3}
                            className={`form-control ${errors.remarks ? "is-invalid" : ""}`}
                            placeholder="Enter Remarks"
                            value={formData.remarks}
                            onChange={handleChange}
                        />

                        {errors.remarks && (
                            <div className="invalid-feedback">
                                {errors.remarks}
                            </div>
                        )}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={closeRemarksPopup}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="primary"
                        onClick={handleRemarksOrder}
                        disabled={remarksLoading}
                    >
                        {remarksLoading ? "Saving..." : "Save"}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
    show={showRemarksHistory}
    onHide={closeRemarksHistory}
    size="lg"
    centered
>
    <Modal.Header closeButton>
        <Modal.Title>
            Remarks History ({selectedRemarks.length})
        </Modal.Title>
    </Modal.Header>

    <Modal.Body>
        {selectedRemarks.length === 0 ? (
            <div className="text-center">No Remarks Found.</div>
        ) : (
            <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Status</th>
                        <th>Follow Up Date</th>
                        <th>Remark</th>
                    </tr>
                </thead>
                <tbody>
                    {selectedRemarks.map((item, index) => (
                        <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.followUpSts}</td>
                            <td>
                                {item.followUpDate
                                    ? new Date(item.followUpDate).toLocaleString("en-IN")
                                    : "-"}
                            </td>
                            <td>{item.remark}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )}
    </Modal.Body>

    <Modal.Footer>
        <Button variant="secondary" onClick={closeRemarksHistory}>
            Close
        </Button>
    </Modal.Footer>
</Modal>
            {message && <CommonMessage text={message} />}
        </>
    );
};

export default Ringing;